import { Dialog } from "./Dialog.tsx";
import { DialogActions } from "./DialogActions.tsx";

/** Generic "are you sure" dialog before a permanent action, e.g. deleting the current project. */
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  onConfirm,
  onClose,
}: {
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Dialog title={title} onClose={onClose}>
      <p>{message}</p>
      <DialogActions
        primary={{
          label: confirmLabel,
          onClick: () => {
            onConfirm();
            onClose();
          },
          danger: true,
        }}
        onClose={onClose}
      />
    </Dialog>
  );
}
